import React from 'react';
import { Paper } from '@mui/material';
import ForecastBarData from './ForecastBarData';
import ForecastBarGraph from './ForecastBarGraph';
import ForecastPieChart from './ForecastPieChart';

const flexContainerStyle: React.CSSProperties = {
  width: '99%',
  margin: 'auto',
  boxSizing: 'border-box',
  display: 'grid',
  gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
  gridTemplateRows: 'max-content',
  gap: '20px 20px',
};
const flexItemStyle: React.CSSProperties = {
  textAlign: 'center',
  fontSize: '30px',
  display: 'grid',
};
const item1Style: React.CSSProperties = {
  gridColumnStart: 1,
  gridColumnEnd: 6,
};
const item2Style: React.CSSProperties = {
  gridColumnStart: 1,
  gridColumnEnd: 4,
};
const item3Style: React.CSSProperties = {
  gridColumnStart: 4,
  gridColumnEnd: 6,
};

const ForeCastComponent: React.FC = () => {
  return (
    <div>
      <div style={{ ...flexContainerStyle }}>
        <div style={{ ...flexItemStyle, ...item1Style }}>
          <Paper>
            <ForecastBarGraph />
          </Paper>
        </div>
        <div style={{ ...flexItemStyle, ...item2Style }}>
          <Paper>
            <ForecastPieChart />
          </Paper>
        </div>
        <div style={{ ...flexItemStyle, ...item3Style }}>
          <Paper>
            <ForecastBarData />
          </Paper>
        </div>
      </div>
    </div>
  );
};

export default ForeCastComponent;
